import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Link, useParams } from "react-router-dom";
import axios from "axios";
import { Container, Spinner} from "react-bootstrap";
import { showToast } from '../../../components/common/notification/Notification';
import PromotionDetailCard from "./PromotionDetailCard";

const PromoSingle = ({backbtn, ownerId: setOwnerId}) => {
  const { Id } = useParams();
  const [promotionData, setPromotionData] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [isError, setIsError] = useState(false);
  const loggedInUser = useSelector((state) => state.auth.user);
  const token = loggedInUser?.refreshToken;
  const baseUrl = process.env.REACT_APP_BASE_URL;
  const assetUrl = process.env.REACT_APP_ASSET_URL;

  const [mediaData, setMediaData] = useState({
    images: [],
    promotion_videos: [],
    attachments: [],
  });

  useEffect(() => {
    fetchPromotionItem();
  }, [Id]);

  const fetchPromotionItem = async () => {
    try {
      setIsLoading(true);
      const response = await axios.get(
        `${baseUrl}/promotion/${Id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      ); 
      console.log(response.data.promotion)

      if (response.status === 200) {
        const promotion = response.data.promotion;
        if (setOwnerId && promotion.user) {
          setOwnerId(promotion.user.id); 
        }
        // First update the main data
        setPromotionData({
          images: promotion.propertyImages || [],
          video: promotion.promotion_videos || [],
          attachements: promotion.attachements || [],
          description: promotion.project_description || '',
          title: promotion.project_name || '',
          creater: `${promotion.partner.first_name} ${promotion.partner.last_name}` || '',
          cost: promotion.starting_cost || '',
          type: promotion.property_type.name || '',
          city: promotion.city_name || '',
          state: promotion.state_name || '',
          pin_code: promotion.pin_code || '',
          photo: promotion.partner.first_name || [],
          createdOn: promotion.created_on || '',
        });

        // Now use raw response directly to update media
        setMediaData({
          images: (promotion.propertyImages || []).map((img) => ({
            url: assetUrl + img.image_url,
            // url: `${assetUrl}${img.image_url}`, 
          })),
          promotion_videos: (promotion.promotion_videos || []).map((video) => ({
            url: assetUrl + video.url_path,
          })),
          attachments: (promotion.attachements || []).map((attachment) => ({
            url: assetUrl + attachment.attachment_url,
          })),
        });
      }  
 
      
      else {
        showToast('Failed to fetch data', { type: 'error' });
      }
    } catch (error) {
      setIsError(true);
      console.error('Fetch error:', error);
      showToast('Error fetching data', { type: 'error' }); 
    } finally {
      setIsLoading(false);
    }
  };


  if (isLoading) {
    return (
      <Container className="text-center mt-5">
        <Spinner animation="border" />
      </Container>
    );
  }

  if (!promotionData) {
    return null; // or return a fallback UI if needed
  }
 

  return (

    <div className="container py-4">

      <PromotionDetailCard
        images={mediaData.images}
        videos={mediaData.promotion_videos}
        attachments={mediaData.attachments}
        title={promotionData.title}
        description={promotionData.description}
        cost={promotionData.cost}
        type={promotionData.type}
        state={promotionData.state}
        city={promotionData.city}
        pin_code={promotionData.pin_code}
        photo={promotionData.photo}
        creater={promotionData.creater}
        createdOn={promotionData.createdOn}
      />

      <Link className="btn btn-sm btn-primary fs-5 px-4 py-2 mt-4" to={backbtn}>
        Back 
      </Link>

    </div> 

  );
}
export default PromoSingle;